import Dexie from "dexie";

// Local offline store: a read cache (last-known GET responses) and a
// write queue (pending create/update calls made while offline).
export const db = new Dexie("OrienseamOfflineDB");

db.version(1).stores({
  readCache: "key, entityType",
  writeQueue: "++id, entityType, status, createdAt",
});

export default db;
